import {MyContainer} from '../common/MyContainer'
import {
    FooterWrap,
    FooterTop,
    LogoList,
    LogoItem,
    LogoLink,
    LogoImage,
    FlexLayout,
    Social,
    SocialLabel,
    SocialIconList,
    SocialIconItem,
    SocialIconItemLink,
    FooterMiddle,
    FooterCategory,
    FooterCategoryItem,
    FooterCategoryLink,
    FootetBottom,
    FootetBottomLogoLink,
    FootetBottomText,
    Information,
    InformationTitle,
    InformationList,
    InformationItem,
    InformationLink,
    Title,
    FooterFlex,
    FooterBottomLayout
} from './footerElements'
import {SELECT_CATEGORY_OPTIONS} from '../../global'
import queryString from 'query-string'

const Footer = () => {
    return (
        <FooterWrap>
            <FooterTop className='hide-on-mobile'>
                <MyContainer>
                    <FlexLayout>
                        <LogoList>
                            <LogoItem>
                                <LogoLink title="logo tuổi trẻ TV" to='/'>
                                    <LogoImage src="https://res.cloudinary.com/huyphamcloud/image/upload/v1626348650/tuoitre/LogoTTTV_aidxnn.png" alt="logo tuổi trẻ TV" />
                                </LogoLink>
                            </LogoItem>
                            <LogoItem>
                                <LogoLink title="logo tuổi trẻ cuối tuần" to='/'>
                                    <LogoImage src="https://res.cloudinary.com/huyphamcloud/image/upload/v1625876906/tuoitre/logo2_ttct_2021_mgfne7.png" alt="logo tuổi trẻ cuối tuần" />
                                </LogoLink>
                            </LogoItem>
                            <LogoItem>
                                <LogoLink title="logo tuổi trẻ news" to='/'>
                                    <LogoImage src="https://res.cloudinary.com/huyphamcloud/image/upload/v1626348705/tuoitre/LogoTTNews_bxm8dq.png" alt="logo tuổi trẻ news" />
                                </LogoLink>
                            </LogoItem>
                        </LogoList>
                        <Social>
                            <SocialLabel>Theo dõi Tuổi Trẻ Online: </SocialLabel>
                            <SocialIconList>
                                <SocialIconItem>
                                    <SocialIconItemLink title="Quan tâm Tuổi Trẻ trên Facebook" to='https://www.facebook.com/pqhuy2312/' />
                                </SocialIconItem>
                                <SocialIconItem>
                                    <SocialIconItemLink title="Quan tâm Tuổi Trẻ trên Instagram" to='/' />
                                </SocialIconItem>
                                <SocialIconItem>
                                    <SocialIconItemLink title="Quan tâm Tuổi Trẻ trên Google Plus" to='/' />
                                </SocialIconItem>
                                <SocialIconItem>
                                    <SocialIconItemLink title="Quan tâm Tuổi Trẻ trên Youtube" to='https://www.youtube.com/' />
                                </SocialIconItem>
                            </SocialIconList>
                        </Social>
                    </FlexLayout>
                </MyContainer>
            </FooterTop>
            <FooterMiddle className='hide-on-mobile'>
                <MyContainer>
                    <FooterCategory>
                        {SELECT_CATEGORY_OPTIONS.map((item, index) => (
                            <FooterCategoryItem key={index}>
                                <FooterCategoryLink title={item.label} to={`/category/news?${queryString.stringify({category: item.value})}`}>{item.label}</FooterCategoryLink>
                            </FooterCategoryItem>
                        ))}
                    </FooterCategory>
                </MyContainer>
            </FooterMiddle>
            <FootetBottom>
                <MyContainer style={{display: 'flex', alignItems: 'center'}}>
                    <FooterBottomLayout>
                        <FooterFlex>
                            <FootetBottomLogoLink title='Tuổi Trẻ Online' to='/' />
                            <FootetBottomText>
                                © Copyright 2021 TuoiTre Online, All rights reserved<br />
                                ® Tuổi Trẻ Online giữ bản quyền nội dung trên website này
                            </FootetBottomText>
                        </FooterFlex>
                        <Information>
                            <Title>
                                <InformationTitle to='/'>Thông tin Tòa soạn -</InformationTitle>
                                <InformationTitle to='/'>Thành Đoàn TP.HCM</InformationTitle>
                            </Title>
                            <InformationList>
                                <InformationItem>
                                    <InformationLink to='/'>Liên hệ Quảng cáo</InformationLink>
                                </InformationItem>
                                <InformationItem>
                                    <InformationLink to='/'>Điều khoản bảo mật</InformationLink>
                                </InformationItem>
                                <InformationItem>
                                    <InformationLink to='/'>Liên hệ góp ý</InformationLink>
                                </InformationItem>
                                <InformationItem className='hide-on-mobile-tablet'>
                                    <InformationLink to='/'>Hotline: 0918.033.133</InformationLink>
                                </InformationItem>
                            </InformationList>
                        </Information>
                    </FooterBottomLayout>
                </MyContainer>
            </FootetBottom>
        </FooterWrap>
    )
}

export default Footer
